export const CommodityIntelegenceTowerTypes = {
  SET_SCREEN: "SET_SCREEN",
  SET_CIT_DATA: "SET_CIT_DATA",
  SET_POWERBI_DATA: "SET_POWERBI_DATA",
};
